import { render, staticRenderFns } from "./AssetsVehiclesUpdateDriverForm.vue?vue&type=template&id=aba075c6&"
import script from "./AssetsVehiclesUpdateDriverForm.vue?vue&type=script&lang=js&"
export * from "./AssetsVehiclesUpdateDriverForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports